import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { AppService } from "../../service/app.service";
import { CustomerService } from "../../service/customer.service";
import { map, mergeMap } from "rxjs";
import { OnboardingService } from "../../service/onboarding.service";
import { AuthenticationService } from "../../service/authentication.service";
import { OnboardingProgressState } from "../../gql/generated";
import { NzNotificationService } from "ng-zorro-antd/notification";

@Component({
    selector: 'app-email-verify',
    templateUrl: './email-verify.component.html',
    styleUrls: ['./email-verify.component.less'],
    standalone: true,
  })
export class EmailVerifyComponent implements OnInit{

  token = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public appService: AppService,
    private customerService: CustomerService,
    private onboardingService: OnboardingService,
    private authenticationService: AuthenticationService,
    private nzNotificationService: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'] || '';
      this.customerService.verifyCustomerAccount(this.token).pipe(
        mergeMap(() => {
          return this.customerService.getActiveCustomer()
        }),
        mergeMap((response) => {
            return this.onboardingService.updateOnboarding({
              emailAddress: response?.data?.activeCustomer?.emailAddress,
              state: OnboardingProgressState.SMS_VERIFICATION
            })
        }),
      ).subscribe((response) => {
        const error = response.data?.updateOnboarding as {
          errorCode?: string
          message?: string
        }
        if (error?.errorCode) {
          this.nzNotificationService.error(
            error.errorCode,
            error.message as string
          )
        } else {
          this.router.navigate(['/verify'])
        }
      })
    });
  }
}